import { Quill } from "vue-quill-editor";
const BlockEmbed = Quill.import("blots/block/embed");
class VideoBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute("src", value && value.url);
    node.setAttribute("id", value && value.videoId + "_uploaded_video");
    node.setAttribute("class", "ql-video");
    node.setAttribute("controls", value.controls);
    node.setAttribute("width", value.width);
    node.setAttribute("height", value.height);
    node.setAttribute("webkit-playsinline", true);
    node.setAttribute("playsinline", true);
    node.setAttribute("x5-playsinline", true);
    node.setAttribute("allowfullscreen", true);
    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute("src"),
      id: node.getAttribute("id"),
      controls: node.getAttribute("controls"),
      width: node.getAttribute("width"),
      height: node.getAttribute("height")
    };
  }
}

VideoBlot.blotName = "uploadedVideo";
VideoBlot.tagName = "iframe";
Quill.register(VideoBlot);
